// metaobject-design-selection-modal.js - NO THUMBNAIL OVERRIDE VERSION
// This version ensures the main design image is ALWAYS used, never thumbnails

document.addEventListener("DOMContentLoaded", function() {
  const designDataElement = document.getElementById("designs-data");
  if (!designDataElement) {
    console.error("metaobject-design-selection-modal.js: Design data script tag not found.");
    return;
  }

  let designs = [];
  let selectionMethod = "modal";
  let translations = {};

  try {
    const data = JSON.parse(designDataElement.textContent);
    designs = data.designs || [];
    selectionMethod = data.selectionMethod || "modal";
  } catch (e) {
    console.error("metaobject-design-selection-modal.js: Error parsing design data JSON:", e);
    return;
  }

  // --- Elements from product-design-selection.liquid ---
  const openModalButton = document.getElementById("browseDesignsBtn");
  const selectedDesignPreview = document.getElementById("selected-design-preview");
  const selectedDesignThumbnail = document.getElementById("selected-design-thumbnail");
  const selectedDesignLabel = document.getElementById("selected-design-label");
  const buttonTextSpan = openModalButton ? openModalButton.querySelector(".button-text") : null;

  const previewImage = document.getElementById("preview-image");
  const designInfo = document.getElementById("design-info");
  const selectedDesignName = document.getElementById("selected-design-name");
  const selectedDesignId = document.getElementById("selected-design-id");
  const selectedDesignDescription = document.getElementById("selected-design-description");

  const hiddenDesignIdInput = document.getElementById("selectedDesignIdValue");
  const hiddenDesignNameInput = document.getElementById("hidden-design-name");
  const hiddenDesignImageInput = document.getElementById("selectedDesignImageValue");

  // --- Elements from design-selection-modal.liquid ---
  const modal = document.getElementById("design-selection-modal");
  const closeModalButton = document.getElementById("close-modal-button");
  const selectDesignButton = document.getElementById("select-design-button");
  const cancelSelectionButton = document.getElementById("cancel-selection-button");
  const designGrid = document.getElementById("design-grid");

  let currentSelectedDesign = null;
  let confirmedDesign = null;
  let clickTimeout = null;

  // Function to validate and fix image URLs
  function validateAndFixImageUrl(url) {
    if (!url || typeof url !== 'string') {
      console.warn('Invalid URL provided:', url);
      return '';
    }

    let cleanUrl = url.trim();
    
    if (!cleanUrl) {
      return '';
    }

    if (cleanUrl.startsWith('//')) {
      cleanUrl = 'https:' + cleanUrl;
    }
    else if (cleanUrl.startsWith('/')) {
      cleanUrl = window.location.origin + cleanUrl;
    }
    else if (!cleanUrl.match(/^https?:\/\//)) {
      cleanUrl = 'https://' + cleanUrl;
    }

    try {
      new URL(cleanUrl);
      return cleanUrl;
    } catch (error) {
      console.error('Invalid URL format after processing:', cleanUrl, error);
      return '';
    }
  }

  // Function to get Shopify image URL with specified size
  function getShopifyImageUrl(src, size) {
    if (!src) return '';
    
    const validUrl = validateAndFixImageUrl(src);
    if (!validUrl) return '';
    
    let cleanSrc = validUrl.replace(/_\d+x\d*\./, '.');
    cleanSrc = cleanSrc.replace(/_\d+x\./, '.');
    cleanSrc = cleanSrc.replace(/_large\./, '.');
    cleanSrc = cleanSrc.replace(/_medium\./, '.');
    cleanSrc = cleanSrc.replace(/_small\./, '.');

    const parts = cleanSrc.split('.');
    const extension = parts.pop();
    const filename = parts.join('.');
    return `${filename}_${size}.${extension}`;
  }

  // --- Functions ---

  function updateDesignPreview(design) {
    if (design) {
      // ALWAYS use the main image, never thumbnail
      const validImageUrl = validateAndFixImageUrl(design.image);
      previewImage.src = validImageUrl;
      previewImage.alt = design.image_alt;
      
      document.getElementById("design-preview-container").style.display = "block";
    } else {
      previewImage.src = "";
      previewImage.alt = "";
      document.getElementById("design-preview-container").style.display = "none";
    }
  }

  function updateTriggerButton(design) {
    if (design && buttonTextSpan && selectedDesignPreview && selectedDesignThumbnail && selectedDesignLabel) {
      buttonTextSpan.style.display = "none";
      
      const imageToUse = design.image; // ALWAYS use main image
      const validImageUrl = validateAndFixImageUrl(imageToUse);
      
      selectedDesignThumbnail.src = validImageUrl;
      selectedDesignThumbnail.alt = design.image_alt;
      selectedDesignLabel.textContent = design.name;
      selectedDesignPreview.style.display = "flex";
      
    } else if (buttonTextSpan && selectedDesignPreview) {
      buttonTextSpan.style.display = "block";
      selectedDesignPreview.style.display = "none";
    }
  }

  function updateHiddenInputs(design) {
    if (hiddenDesignIdInput && hiddenDesignNameInput && hiddenDesignImageInput) {
      hiddenDesignIdInput.value = design ? design.id : "";
      hiddenDesignNameInput.value = design ? design.name : "";
      
      // 🔥 CRITICAL FIX: ALWAYS use main image, NEVER thumbnail
      const validImageUrl = design ? validateAndFixImageUrl(design.image) : "";
      hiddenDesignImageInput.value = validImageUrl;
      
      // 🔥 FORCE UPDATE: Ensure the hidden input actually has the value
      setTimeout(() => {
        if (hiddenDesignImageInput.value !== validImageUrl) {
          console.error('🚨 HIDDEN INPUT VALUE WAS OVERRIDDEN!');
          console.error('Expected:', validImageUrl);
          console.error('Actual:', hiddenDesignImageInput.value);
          hiddenDesignImageInput.value = validImageUrl;
        }
      }, 100);
    }
  }

  function confirmDesignSelection(design) {
    confirmedDesign = design;
        
    // Update all UI elements
    updateDesignPreview(confirmedDesign);
    updateTriggerButton(confirmedDesign);
    updateHiddenInputs(confirmedDesign);
    
    // 🔥 ADDITIONAL SAFETY CHECK: Verify hidden input after all updates
    setTimeout(() => {
      const expectedUrl = validateAndFixImageUrl(design.image);
      const actualUrl = hiddenDesignImageInput ? hiddenDesignImageInput.value : 'N/A';
      
      if (actualUrl !== expectedUrl) {
        console.error('🚨 MISMATCH DETECTED - FORCING CORRECTION');
        if (hiddenDesignImageInput) {
          hiddenDesignImageInput.value = expectedUrl;
        }
      } else {
        console.log('✅ VERIFICATION PASSED');
      }
    }, 200);
    
    // Close modal
    modal.classList.remove("is-open");
    document.body.classList.remove("modal-open");
  }

  function populateDesignGrid() {

    if (!designGrid) {
      console.error("metaobject-design-selection-modal.js: designGrid element NOT FOUND!");
      return;
    }
    
    designGrid.innerHTML = "";

    designs.forEach(design => {
      // 🔥 CRITICAL: Use main image for grid, not thumbnail
      const imageUrl = getShopifyImageUrl(design.image, '600x'); 

      const isSelectedClass = (confirmedDesign && confirmedDesign.id === design.id) ? ' selected' : '';
      const designCardHtml = `
        <div class="design-card${isSelectedClass}" data-design-id="${design.id}">
          <img src="${imageUrl}" alt="${design.image_alt}" class="design-card-image" onerror="console.error('Failed to load image:', this.src);">
        </div>
      `;
      designGrid.insertAdjacentHTML("beforeend", designCardHtml);
    });

    // Add event listeners to design cards
    designGrid.querySelectorAll(".design-card").forEach(card => {
      card.addEventListener("click", function(event) {
        event.preventDefault();
        
        const selectedDesignIdValue = this.dataset.designId;
        const selectedDesign = designs.find(d => d.id === selectedDesignIdValue);
        
        if (selectedDesign) {
          if (clickTimeout) {
            clearTimeout(clickTimeout);
            clickTimeout = null;
          }
          
          clickTimeout = setTimeout(() => {
            currentSelectedDesign = selectedDesign;
            
            designGrid.querySelectorAll(".design-card").forEach(c => c.classList.remove('selected'));
            this.classList.add('selected');
            selectDesignButton.disabled = false;
          }, 250);
        }
      });

      card.addEventListener("dblclick", function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        if (clickTimeout) {
          clearTimeout(clickTimeout);
          clickTimeout = null;
        }
        
        const selectedDesignIdValue = this.dataset.designId;
        const selectedDesign = designs.find(d => d.id === selectedDesignIdValue);

        if (selectedDesign) {
          currentSelectedDesign = selectedDesign;
          
          designGrid.querySelectorAll(".design-card").forEach(c => c.classList.remove('selected'));
          this.classList.add('selected');
          
          confirmDesignSelection(selectedDesign);
        }
      });
    });
  }

  // --- Event Listeners ---

  if (openModalButton) {
    openModalButton.addEventListener("click", function() {
      populateDesignGrid();
      modal.classList.add("is-open");
      document.body.classList.add("modal-open");
      
      if (confirmedDesign) {
        const selectedCard = designGrid.querySelector(`.design-card[data-design-id="${confirmedDesign.id}"]`);
        if (selectedCard) {
          selectedCard.classList.add('selected');
          currentSelectedDesign = confirmedDesign;
          selectDesignButton.disabled = false;
        }
      } else {
        selectDesignButton.disabled = true;
      }
    });
  }

  if (closeModalButton) {
    closeModalButton.addEventListener("click", function() {
      modal.classList.remove("is-open");
      document.body.classList.remove("modal-open");
      currentSelectedDesign = confirmedDesign;
    });
  }

  if (cancelSelectionButton) {
    cancelSelectionButton.addEventListener("click", function() {
      modal.classList.remove("is-open");
      document.body.classList.remove("modal-open");
      currentSelectedDesign = confirmedDesign;
    });
  }

  if (selectDesignButton) {
    let selectButtonClickTimeout = null;
    
    selectDesignButton.addEventListener("click", function(event) {
      if (selectButtonClickTimeout) {
        clearTimeout(selectButtonClickTimeout);
        selectButtonClickTimeout = null;
      }
      
      selectButtonClickTimeout = setTimeout(() => {
        if (currentSelectedDesign) {
          confirmDesignSelection(currentSelectedDesign);
        }
      }, 250);
    });
    
    selectDesignButton.addEventListener("dblclick", function(event) {
      if (selectButtonClickTimeout) {
        clearTimeout(selectButtonClickTimeout);
        selectButtonClickTimeout = null;
      }
      
      if (currentSelectedDesign) {
        confirmDesignSelection(currentSelectedDesign);
      }
    });
  }

  // 🔥 DEBUGGING HELPERS
  window.debugDesignSelection = function() {    
    return {
      confirmedDesign,
      hiddenInputs: {
        id: hiddenDesignIdInput ? hiddenDesignIdInput.value : null,
        name: hiddenDesignNameInput ? hiddenDesignNameInput.value : null,
        image: hiddenDesignImageInput ? hiddenDesignImageInput.value : null
      }
    };
  };

  window.debugValidateUrl = function(url) {
    const result = validateAndFixImageUrl(url);
    return result;
  };

});
